import React from "react";
import { Container, Section, PageHero, Card, Eyebrow, CTABand } from "@/components/ui-bits/Primitives";
import { BLOG_POSTS, IMAGES } from "@/lib/site-data";
import { Calendar, ArrowRight } from "lucide-react";

export default function Blog() {
    const featured = BLOG_POSTS[0];
    const rest = BLOG_POSTS.slice(1);
    return (
        <div data-testid="blog-page">
            <PageHero
                kicker="News & Insights"
                title="Industry, infrastructure, and impact."
                lead="EV industry news, Texas infrastructure updates, grant program insights, fleet electrification, and charging technology — straight from our team."
                image={IMAGES.evDriving}
                height="h-[45vh] min-h-[360px]"
            />

            <Section>
                <Container>
                    <Eyebrow className="mb-4">Featured</Eyebrow>
                    <article data-testid={`blog-featured`} className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-20 group">
                        <div className="lg:col-span-7 relative overflow-hidden aspect-[16/10]">
                            <img src={featured.image} alt={featured.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                        </div>
                        <div className="lg:col-span-5 flex flex-col justify-center">
                            <div className="text-[11px] uppercase tracking-[0.22em] text-electric-400 mb-3">{featured.category}</div>
                            <h2 className="font-heading text-3xl md:text-4xl text-white tracking-tight leading-tight">{featured.title}</h2>
                            <p className="mt-5 text-slate-400 leading-relaxed">{featured.excerpt}</p>
                            <div className="mt-6 flex items-center gap-2 text-xs text-slate-500"><Calendar className="w-3.5 h-3.5" /> {featured.date}</div>
                            <a href="#" className="btn-ghost mt-6 self-start">Read Article <ArrowRight className="w-4 h-4" /></a>
                        </div>
                    </article>

                    <Eyebrow className="mb-6">Latest</Eyebrow>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {rest.map((p, i) => (
                            <Card key={p.slug} data-testid={`blog-card-${i}`} className="!p-0 overflow-hidden flex flex-col group">
                                <div className="relative aspect-[16/10] overflow-hidden">
                                    <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                                </div>
                                <div className="p-6 flex-1 flex flex-col">
                                    <div className="text-[10px] uppercase tracking-[0.22em] text-electric-400 mb-2">{p.category}</div>
                                    <h3 className="font-heading text-lg text-white leading-snug">{p.title}</h3>
                                    <p className="mt-3 text-sm text-slate-400 leading-relaxed flex-1">{p.excerpt}</p>
                                    <div className="mt-4 flex items-center justify-between text-xs text-slate-500"><span className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5" /> {p.date}</span><a href="#" className="text-electric-400 uppercase tracking-[0.18em] inline-flex items-center gap-1 hover:gap-2 transition-all">Read <ArrowRight className="w-3.5 h-3.5" /></a></div>
                                </div>
                            </Card>
                        ))}
                    </div>
                </Container>
            </Section>

            <CTABand title="Want updates in your inbox?" subtitle="Quarterly insights on Texas EV charging and infrastructure funding." primaryLabel="Subscribe" />
        </div>
    );
}
